import Model from '@/models/Model.js';

export default class ViewInformationActivity extends Model {
    static entity = 'view_information_activities';

    static modelName = 'ViewInformationActivity';

    static fields() {
        return {
            content_template_id: this.attr(null),
            content: this.attr(null),

            ...super.fields(),

            content_template: this.belongsTo('video_activity_templates', 'content_template_id'),
            activity: this.morphOne('activities', 'contentable_id', 'contentable_type_entity'),
        };
    }
}
